<template lang="pug">
el-dialog.modal-produtividade-culturas(
    :title="$t('mensagens.diagnosticoSocioambiental.capacidadeProdutivaPorCultura')"
    :visible='visible'
    :before-close='fechar'
    width='560px'
    append-to-body
)
    p.text-muted.mb-3(v-if='rotuloDaSafra') {{ rotuloDaSafra }}
    el-alert.mb-3(
        v-if='parcial'
        type='warning'
        show-icon
        :closable='false'
        :title="$t('mensagens.diagnosticoSocioambiental.produtividadeParcial')"
    )
    el-card.cultura.mb-3(v-for='card in cards' :key='card.chave' shadow='never')
        h5.cultura__nome(:class="{ 'cultura__nome--com-safra': card.safra }") {{ card.nome }}
        //- GS-4110: com culturas em safras diferentes, cada uma mostra a sua; o rótulo único do topo some
        small.cultura__safra.d-block.text-muted(v-if='card.safra') {{ card.safra }}
        IndicadoresCapacidadeProdutiva(:indicadores='card.indicadores')
    //- RN33: a fonte é fixa; a tabela de inteligência não guarda a fonte do dado (dataSourceName vem nulo)
    small.d-block.text-muted {{ $t('mensagens.diagnosticoSocioambiental.fonteCapacidadeProdutiva') }}
    footer(slot='footer')
        BaseButton(size='mini' @click='fechar') {{ $t('mensagens.comuns.fechar') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import IndicadoresCapacidadeProdutiva from './IndicadoresCapacidadeProdutiva.vue';
import { indicadoresCapacidade, rotuloSafra, nomeCultura, safrasDiferem } from '@/utils/produtividadeCultura';

/**
 * Capacidade produtiva por cultura de um imóvel, na última safra que ele tem (todas as culturas, RN29).
 * Recebe o objeto `produtividade` que o Lyra devolve em GET /diagnostico/produtividade/{car}.
 */
export default {
    name: 'ModalProdutividadeCulturas',

    components: { BaseButton, IndicadoresCapacidadeProdutiva },

    emits: ['update:visible', 'fechar'],

    props: {
        visible: { type: Boolean, default: false },
        produtividade: { type: Object, default: null }
    },

    computed: {
        culturas() {
            return this.produtividade && Array.isArray(this.produtividade.culturas) ? this.produtividade.culturas : [];
        },
        parcial() {
            return !!(this.produtividade && this.produtividade.parcial);
        },
        locale() {
            return this.$i18n.locale;
        },
        // GS-4110: culturas em safras diferentes mostram a safra em cada card, não uma só no topo
        safraPorCultura() {
            return safrasDiferem(this.culturas);
        },
        rotuloDaSafra() {
            return this.safraPorCultura ? null : rotuloSafra(this.produtividade && this.produtividade.safra, this.$t.bind(this));
        },
        // $t e $te precisam do `this` do componente (vue-i18n lê this.$i18n): passar `$t` solto a um util quebra o render
        cards() {
            const t = this.$t.bind(this);
            const te = this.$te.bind(this);
            return this.culturas.map(cultura => ({
                chave: cultura.cultura,
                nome: nomeCultura(cultura.cultura, t, te),
                safra: this.safraPorCultura ? rotuloSafra(cultura.safra, t) : null,
                indicadores: indicadoresCapacidade(cultura, this.locale)
            }));
        }
    },

    methods: {
        fechar() {
            this.$emit('update:visible', false);
            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-produtividade-culturas ::v-deep .el-dialog {
    max-width: 92vw;
}

.cultura {
    &__nome {
        margin-bottom: 12px;
        font-size: 16px;
        font-weight: 500;
        color: var(--primary);

        // com a safra logo abaixo, o respiro vai para depois dela (.cultura__safra)
        &--com-safra {
            margin-bottom: 2px;
        }
    }

    &__safra {
        margin-bottom: 12px;
    }
}
</style>
